var nextUniqueId = 0;
export default function getNextUniqueId() {
  return nextUniqueId++;
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/utils/getNextUniqueId.js
// module id = 667
// module chunks = 4